import { CollectedResourceBaseCountersModel } from './collected-resource-base-counters-model';

export class GlobalResourcesStateModel extends CollectedResourceBaseCountersModel {
  missed: number;
}
